import React from 'react';
// Same overlay and card as "Request Accepted" (its CSS is global once imported), so the two outcomes
// of the handshake read as one family.
import './AcceptedRequestModal.css';

// 2026-09-16: shown when the owner answers "I can't see them" to the requester's "I've arrived".
const ArrivalRejectedModal = ({ onClose, ownerUsername }) => (
  <div className="modal-overlay" onClick={onClose}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <span className="close-modal-x" onClick={onClose}>&times;</span>
      <h2 className="title">{ownerUsername} can't see you yet</h2>
      <p>Make sure you're at the right spot, then press Arrived again.</p>
      <div className="btn-row">
        <button type="button" className="btn btn--primary" onClick={onClose}>OK</button>
      </div>
    </div>
  </div>
);

export default ArrivalRejectedModal;
